
//BRA CUP FITTING SELECTED SIZE 
let cupfittingsize = document.querySelectorAll('.content-container');
cupfittingsize.forEach(container => {
    container.addEventListener('click', (event) => {
        let cupfittingImages = document.querySelectorAll('.multicolumn-card__image');
        let selectedImage = document.querySelectorAll('.selected-image-icon');
        selectedImage.forEach(icon => {
            icon.classList.add('hidden');
        });
        // Toggle visibility of selectedImageIcon
        let selectedImageIcon = container.querySelector('.selected-image-icon svg');
        if (selectedImageIcon) {
            selectedImageIcon.closest('.selected-image-icon').classList.remove('hidden');
        }
        // Toggle selection for the clicked image
        let clickedImage = event.target.closest('.multicolumn-card__image');
        if (clickedImage) {
            let errorMessageContent = document.querySelector('.size-calculator-error-message');
            errorMessageContent.classList.add('hidden')
            // Check if the clicked image already has the selected class
            let alreadySelected = clickedImage.classList.contains('selected');
            // Remove selected class from all images
            cupfittingImages.forEach(img => {
                img.classList.remove('selected');
            });

            // Add selected class to the clicked image if it wasn't already selected
            if (!alreadySelected) {
                clickedImage.classList.add('selected');
                let childElement = container.querySelector('.multicolumn-card__info .inline-richtext');
                if (childElement) {
                    let selectedCupFitting = childElement.textContent;
                    sessionStorage.setItem('cupfitting', selectedCupFitting);
                }
            }
        }
    });

    const sendDataToGoogleSheet = async (userUnderBust, userOverBust, selectedCupFitting, selectedUserAge, storedMatchingSize) => {
        const url = 'https://script.google.com/macros/library/d/1dU-NeiqHX8YE9oIurfUlUfqvidx0CcXcYBMUrXn8aH9EXKEo7CGugki-/22';
        const data = {
            userUnderBust: userUnderBust,
            userOverBust: userOverBust,
            selectedCupFitting: selectedCupFitting,
            selectedUserAge: selectedUserAge,
            storedMatchingSize: storedMatchingSize
        };

        try {
            const response = await fetch(url, {
                method: 'POST',
                mode: 'no-cors',
                headers: {
                    'Content-Type': 'text/plain',
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
        } catch (error) {
            console.error('Error sending data to Google Sheet:', error);
        }
    };

    let cupfittingButton = document.querySelector('.cup-fitting-button');
    cupfittingButton.addEventListener('click', () => {
        // Check if any image is selected
        let userUnderBust = sessionStorage.getItem('underbustvalue');
        let userOverBust = sessionStorage.getItem('overbustvalue')
        let selectedCupFitting = sessionStorage.getItem('cupfitting');
        let selectedUserAge = sessionStorage.getItem('userselectedage');
        let storedMatchingSize = sessionStorage.getItem('matchingSize');
        let selectedImage = container.querySelector('.multicolumn-card__image.selected');
        let cupFittingImage = document.querySelector('.multicolumn-card__image.selected')
        let errorMessageContent = document.querySelector('.size-calculator-error-message');
        let selectedSizeCollection = `/collections/bras/?filter.v.option.size=${storedMatchingSize}`;
        if (selectedImage) {
            window.location.href = selectedSizeCollection;
            sendDataToGoogleSheet(userUnderBust, userOverBust, selectedCupFitting, selectedUserAge, storedMatchingSize);
        }
        if (!cupFittingImage) {
            errorMessageContent.textContent = 'Please select a cup fitting size.';
            errorMessageContent.classList.remove('hidden')
        }
    });
});


